export default "__VITE_ASSET__DS6KKCQ1__"